<template>
    <section class="comments">
        <Heading :h="3" size="xl">{{ siteContent.comments }}</Heading>
        <PostComment
            v-if="auth.id"
            :collection="collection"
            :documentId="documentId"
            :notificationDetails="notificationDetails"/>
        <div class="logIn"
            v-else>
            <span v-if="comments.length !== 0">
                <router-link to="/auth">
                    {{ siteContent.loginPrompt }}
                </router-link>
                {{ siteContent.toJoinTheConversation }}
            </span>
            <span v-else>
                {{ siteContent.noCommentsYet }}
                <router-link to="/auth">
                    {{ siteContent.loginPrompt }}
                </router-link>
                {{ siteContent.toStartaConversation }}
            </span>
        </div>
        <Loader v-if="loading"/>
        <ol class="commentSection"
            v-else>
            <Comment v-for="comment in comments"
                :key="comment.id"
                :collection="collection"
                :content="comment.content"
                :timestamp="comment.timestamp"
                :writtenBy="comment.writtenBy"
                :parentId="comment.id"
                :documentId="documentId"
                :notificationDetails="notificationDetails"/>
        </ol>
    </section>
</template>

<script>
    import PostComment from '@/components/comments/PostComment'
    import Comment from '@/components/comments/Comment'

    import { db } from '@/firebase'

    export default {
        name: 'Comments',
        components: {
            PostComment,
            Comment
        },
        props: {
            collection: {
                type: String,
                required: true
            },
            documentId: {
                type: String,
                required: true
            },
            notificationDetails: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                comments: [],
                loading: true
            }
        },
        mounted() {
            this.fetchComments()
        },
        methods: {
            async fetchComments() {
                await db
                .collection(this.collection)
                .orderBy('timestamp', 'desc')
                .onSnapshot(snapshot => {
                    const comments = snapshot.docs
                    .filter(doc => doc.data().doc === this.documentId)
                    .map(doc => {
                        return { 
                            id: doc.id,
                            ...doc.data()
                        }
                    })

                    this.comments = comments
                    this.loading = false

                    return () => cleanUp()
                })
            }
        },
        watch: {
            // call again the method if the route changes
            '$route' (to, from) {
                this.fetchComments()
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .comments {
        display: flex;
        flex-direction: column;
        flex: 1;
        width: 100%;
    }

    .commentSection {
        padding: 0;
        margin: 0;
    }

    .h3 {
        margin: 0 0 1.5rem 0;
    }

    .logIn {
        margin: -1rem 0 3rem 0;
        color: var(--color-grey-600);
    }
</style>